import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cmd01200-form-area cmd01200-form" }
const _hoisted_2 = { style: {"padding-right":"57px","margin":"0 auto"} }
const _hoisted_3 = {
  key: 0,
  style: {"width":"80px"}
}
const _hoisted_4 = {
  key: 1,
  style: {"width":"80px"}
}
const _hoisted_5 = { class: "q-gutter-sm row items-center q-mr-md" }
const _hoisted_6 = {
  key: 0,
  class: "text-right",
  style: {"width":"200px","height":"21px","padding-right":"0.5rem"},
  textContent: 0
}
const _hoisted_7 = { class: "q-gutter-sm row items-center q-mr-md" }
const _hoisted_8 = { style: {"padding-left":"40px"} }
const _hoisted_9 = { class: "q-gutter-sm row items-center q-mr-md" }
const _hoisted_10 = { class: "q-gutter-x-xs flex justify-end cmd01200-button-area" }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import {
  isEmpty,
  isNumeric,
  isTwoDecimalPlaces,
  isMoneyType,
} from '../../common/utils/validateUtils';
import messages from '../../messages/message.json';

const DIALOG_LEVEL = 'information';
// ダイアログのtitle

export default /*@__PURE__*/_defineComponent({
  __name: 'CMD01200',
  setup(__props) {

const router = useRouter();
// ダイアログのdisplayFlg(表示判断)
const dialogDisplayFlg = ref(false);
// ダイアログのlevel(informationで固定)
const dialogTitle = ref('');
// ダイアログのtext
const dialogText = ref(['']);
// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConfFlg = ref(false);
// エラーメッセージ表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');

// リセット用データ
const resetData = reactive([
  {
    lower_price_limit: '',
    upper_price_limit: '',
    coefficient: '',
    isAllEmpty: false,
    lowErrFlg: false,
    upErrFlg: false,
    coefErrFlg: false,
  },
]);

// 入力データ
const inputData = ref({ ...resetData });

/**
 * エラーメッセージ表示
 */
const displayErrMsg = () => {
  errMessage.value = messages.ja.message.MSG_50070E;
  isMessageChip.value = true;
  // TOPにスクロール
  setTimeout(() => window.scrollTo({ top: 0 }), 400);
};

/**
 * エラーチップを初期化
 */
/* eslint-disable @typescript-eslint/no-unused-vars */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * エラー初期化
 */
const resetErrors = () => {
  // メッセージチップを非表示にし、メッセージを初期化
  errMessage.value = '';
  isMessageChip.value = false;

  // 全区分の全項目を白に変更
  for (let index = 0; index < 20; index += 1) {
    inputData.value[index].lowErrFlg = false;
    inputData.value[index].upErrFlg = false;
    inputData.value[index].coefErrFlg = false;
  }
};

/**
 * 下限、上限からカンマを取り除く処理
 */
const removeComma = () => {
  for (let index = 0; index < 20; index += 1) {
    const low = inputData.value[index].lower_price_limit;
    const up = inputData.value[index].upper_price_limit;

    if (low !== null && low !== '') {
      // 下限価格からカンマを取り除く
      inputData.value[index].lower_price_limit = low.split(',').join('');
    }
    if (up !== null && up !== '') {
      // 上限価格からカンマを取り除く
      inputData.value[index].upper_price_limit = up.split(',').join('');
    }
  }
};

/**
 * 下限、上限にカンマを付け、係数の小数部を2桁にする処理
 */
const attachComma = () => {
  for (let index = 0; index < 20; index += 1) {
    const low = inputData.value[index].lower_price_limit;
    const up = inputData.value[index].upper_price_limit;
    const coef = inputData.value[index].coefficient;

    if (low !== null && low !== '') {
      // 下限価格にカンマを付ける
      inputData.value[index].lower_price_limit = Number(low).toLocaleString();
    } else {
      inputData.value[index].lower_price_limit = '';
    }
    if (up !== null && up !== '') {
      // 上限価格にカンマを付ける
      inputData.value[index].upper_price_limit = Number(up).toLocaleString();
    } else {
      inputData.value[index].upper_price_limit = '';
    }
    if (coef !== null && coef !== '') {
      // 係数の小数部を2桁に固定する
      inputData.value[index].coefficient = Number(coef).toFixed(2);
    } else {
      inputData.value[index].coefficient = '';
    }
  }
};

/**
 * 入力値リセット
 */
const reset = () => {
  resetErrors();
  for (let index = 0; index < 20; index += 1) {
    inputData.value[index] = { ...resetData[index] };
  }
  // 下限と上限にカンマをつけ、係数の小数部を2桁にする
  attachComma();
  // TOPにスクロール
  setTimeout(() => window.scrollTo({ top: 0 }), 400);
};

/**
 * 入力エラーがない場合にダイアログの中身を設定、表示する処理
 */
const submit = () => {
  // 変更確認ダイアログのtitle、textを設定
  dialogTitle.value = '更新確認';
  dialogText.value = ['入力された内容で更新します。', 'よろしいですか？'];
  // ダイアログを表示
  dialogDisplayFlg.value = true;
};

/**
 * ダイアログのキャンセルボタン押下時の処理
 */
const closeDialog = () => {
  dialogDisplayFlg.value = false;
  // TOPにスクロール
  setTimeout(() => window.scrollTo({ top: 0 }), 400);
};

/**
 * 初期表示処理
 */
const getCoefficients = async () => {
  // Loading Start
  Loading.show();
  axios
    .post('/cmd012001/getCoefficients')
    .then((res) => {
      const { common, coefficientList } = res.data;

      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // リセット用データを初期化後、取得した値を格納
          resetData.splice(0);
          Object.assign(resetData, coefficientList);

          // 要素数が20になるまで配列の要素を追加する
          for (let index = coefficientList.length; index < 20; index += 1) {
            resetData.push({
              lower_price_limit: '',
              upper_price_limit: '',
              coefficient: '',
              isAllEmpty: false,
              lowErrFlg: false,
              upErrFlg: false,
              coefErrFlg: false,
            });
          }

          for (let index = 0; index < 20; index += 1) {
            inputData.value[index] = { ...resetData[index] };
          }

          // 下限と上限にカンマをつけ、係数の小数部を2桁にする
          attachComma();
          // TOPにスクロール
          setTimeout(() => window.scrollTo({ top: 0 }), 400);
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // ダイアログを非表示にし、キャンセルボタン表示判断をfalseに
      dialogDisplayFlg.value = false;
      dialogConfFlg.value = false;
      // Loading End
      Loading.hide();
    });
};

/**
 * 円転後仕入価格と係数の変更処理
 */
const editCoefficients = async () => {
  // Loading Start
  Loading.show();
  // 下限、上限からカンマを取り除く
  removeComma();

  // 更新用データセット
  const formData = new FormData();
  for (let index = 0; index < 20; index += 1) {
    if (inputData.value[index].isAllEmpty) {
      break;
    }
    formData.append(
      `editCoefficientList[${index}][lower_price_limit]`,
      index === 0 ? '0' : inputData.value[index].lower_price_limit
    );
    formData.append(
      `editCoefficientList[${index}][upper_price_limit]`,
      inputData.value[index].upper_price_limit
    );
    formData.append(
      `editCoefficientList[${index}][coefficient]`,
      Number(inputData.value[index].coefficient).toString()
    );
  }

  // 円転後仕入価格と係数の変更を行うController呼び出し
  await axios
    .post('/cmd012001/editCoefficients', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 下限と上限にカンマをつけ、係数の小数部を2桁にする
          attachComma();
          // 変更確認ダイアログのtitle、textを設定し、キャンセルボタン表示判断をtrueに
          dialogTitle.value = '更新完了';
          dialogText.value = ['更新が完了しました。'];
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              // 下限と上限にカンマをつけ、係数の小数部を2桁にする
              attachComma();
              // ダイアログを非表示
              dialogDisplayFlg.value = false;
              // メッセージチップにエラーメッセージを表示
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;
            case DetailResultStatusCode.PARAMETER_ERROR:
              // ダイアログを非表示
              dialogDisplayFlg.value = false;
              // メッセージチップにエラーメッセージを表示
              errMessage.value = common.message;
              isMessageChip.value = true;
              setTimeout(() => window.scrollTo({ top: 0 }), 400);
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 入力値のエラーチェック
 */
const checkData = () => {
  resetErrors();
  // 下限、上限からカンマを取り除く
  removeComma();
  // 入力データの配列を逆から回し、入力があった時点でtrue
  const inputFlg = ref(false);

  for (let index = 19; index > 0; index -= 1) {
    const low = inputData.value[index].lower_price_limit;
    const up = inputData.value[index].upper_price_limit;
    const coef = inputData.value[index].coefficient;

    if (
      (low === null || low === '') &&
      (up === null || up === '') &&
      (coef === null || coef === '')
    ) {
      // 全項目が未入力の区分
      inputData.value[index].isAllEmpty = true;
    } else {
      // 1項目でも入力されている区分
      inputData.value[index].isAllEmpty = false;
      inputFlg.value = true;
    }

    // 1項目でも入力のある区分以前に全項目未入力の区分がないかチェック
    if (inputFlg.value && inputData.value[index].isAllEmpty) {
      // 入力エラーの条件に該当する場合、エラーメッセージを表示
      errMessage.value = messages.ja.message.MSG_50061E;
      isMessageChip.value = true;
      // 入力エラーの条件に該当する区分の全項目を赤く表示
      inputData.value[index].lowErrFlg = true;
      inputData.value[index].upErrFlg = true;
      inputData.value[index].coefErrFlg = true;
    }
  }

  // ここまでの入力値チェックでエラーがなかった場合のみ、この処理を行う
  if (!isMessageChip.value) {
    for (let index = 1; index < 20; index += 1) {
      // チェックを行う区分の各データを変数にセット
      const low = inputData.value[index].lower_price_limit;
      const up = inputData.value[index].upper_price_limit;
      const coef = inputData.value[index].coefficient;

      // 区分ごとに全項目が入力されているかチェック
      if (!inputData.value[index].isAllEmpty) {
        const noDataFlg = ref(false);
        // 入力エラーの条件に該当する項目を赤く表示
        if (low === null || low === '') {
          inputData.value[index].lowErrFlg = true;
          noDataFlg.value = true;
        }
        if (up === null || up === '') {
          inputData.value[index].upErrFlg = true;
          noDataFlg.value = true;
        }
        if (coef === null || coef === '') {
          inputData.value[index].coefErrFlg = true;
          noDataFlg.value = true;
        }
        // 入力エラーの条件に該当する場合、エラーメッセージを表示
        if (noDataFlg.value) {
          errMessage.value = messages.ja.message.MSG_50062E;
          isMessageChip.value = true;
        }
      }
    }
  }

  // ここまでの入力値チェックでエラーがなかった場合のみ、この処理を行う
  if (!isMessageChip.value) {
    for (let index = 1; index < 20; index += 1) {
      // チェックを行う区分の各データを変数にセット
      const low = inputData.value[index].lower_price_limit;

      if (!inputData.value[index].isAllEmpty) {
        // 入力値の下限と前区分の上限が一致しているかつ、入力値が99999999の場合
        if (
          Number(low) === Number(inputData.value[index - 1].upper_price_limit) &&
          Number(inputData.value[index - 1].upper_price_limit) === 99999999
        ) {
          // 入力エラーの条件に該当する場合、エラーメッセージを表示
          errMessage.value = messages.ja.message.MSG_50063E;
          isMessageChip.value = true;
          // 入力エラーの条件に該当する下限価格を赤く表示
          inputData.value[index].lowErrFlg = true;
          break;
        }

        // 下限価格に前区分の上限価格と同じ金額が入力されているかチェック
        if (Number(low) !== Number(inputData.value[index - 1].upper_price_limit)) {
          // 入力エラーの条件に該当する場合、エラーメッセージを表示
          errMessage.value = messages.ja.message.MSG_50064E;
          isMessageChip.value = true;
          // 入力エラーの条件に該当する下限価格を赤く表示
          inputData.value[index].lowErrFlg = true;
          break;
        }

        // 入力されている最大区分の場合break
        if (index === 19) {
          break;
        }
        if (inputData.value[index + 1].isAllEmpty) {
          break;
        }
        // 上限価格に下限価格を上回る金額が入力されているかチェック
        if (Number(low) >= Number(inputData.value[index].upper_price_limit)) {
          // 入力エラーの条件に該当する場合、エラーメッセージを表示
          errMessage.value = messages.ja.message.MSG_50065E;
          isMessageChip.value = true;
          // 入力エラーの条件に該当する上限価格を赤く表示
          inputData.value[index].upErrFlg = true;
          break;
        }
      }
    }
  }

  // ここまでの入力値チェックでエラーがなかった場合のみ、この処理を行う
  if (!isMessageChip.value) {
    // 区分20の上限価格に99,999,999が入力されているかチェック
    if (!inputData.value[19].isAllEmpty) {
      if (Number(inputData.value[19].upper_price_limit) !== 99999999) {
        // 入力エラーの条件に該当する場合、エラーメッセージを表示
        errMessage.value = messages.ja.message.MSG_50066E;
        isMessageChip.value = true;
        // 入力エラーの条件に該当する上限価格を赤く表示
        inputData.value[19].upErrFlg = true;
      }
    } else {
      for (let index = 1; index < 20; index += 1) {
        // 入力されている最大区分の上限価格に99,999,999が入力されているかチェック
        if (inputData.value[index].isAllEmpty) {
          if (Number(inputData.value[index - 1].upper_price_limit) !== 99999999) {
            // 入力エラーの条件に該当する場合、エラーメッセージを表示
            errMessage.value = messages.ja.message.MSG_50066E;
            isMessageChip.value = true;
            // 入力エラーの条件に該当する上限価格を赤く表示
            inputData.value[index - 1].upErrFlg = true;
          }
          break;
        }
      }
    }
  }

  // 下限と上限にカンマをつけ、係数の小数部を2桁にする
  attachComma();
  if (!isMessageChip.value) {
    // 入力値にエラーがなかった場合、ダイアログを表示する
    submit();
  } else {
    // 入力値にエラーがあった場合、TOPにスクロール
    setTimeout(() => window.scrollTo({ top: 0 }), 400);
  }
};

/**
 * 初期表示処理呼び出し
 */
getCoefficients();

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("円転後仕入価格帯別係数設定")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MessageChip, {
        display: isMessageChip.value,
        level: "E",
        message: errMessage.value
      }, null, 8, ["display", "message"]),
      _createVNode(_component_q_form, {
        class: "q-mt-md",
        autofocus: "",
        greedy: "",
        novalidate: "",
        onSubmit: _withModifiers(checkData, ["prevent"]),
        onReset: reset,
        onValidationError: displayErrMsg
      }, {
        default: _withCtx(() => [
          _createElementVNode("table", _hoisted_2, [
            _cache[10] || (_cache[10] = _createElementVNode("tr", null, [
              _createElementVNode("th", {
                colspan: "2",
                style: {"padding-left":"80px"}
              }, "下限"),
              _createElementVNode("th", null, "上限"),
              _createElementVNode("th", { style: {"padding-left":"40px"} }, "係数")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputData.value, (data, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                (Number(index) < 9)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_3, "区分 " + _toDisplayString(Number(index) + 1) + ":", 1))
                  : _createCommentVNode("", true),
                (Number(index) >= 9)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_4, "区分" + _toDisplayString(Number(index) + 1) + ":", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_5, [
                    (Number(index) === 0)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_6))
                      : _createCommentVNode("", true),
                    (Number(index) !== 0)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 1,
                          modelValue: data.lower_price_limit,
                          "onUpdate:modelValue": ($event: any) => ((data.lower_price_limit) = $event),
                          outlined: "",
                          clearable: "",
                          dense: "",
                          style: {"width":"200px"},
                          maxlength: "10",
                          "input-class": "text-right",
                          class: "input-area exception-right",
                          error: data.lowErrFlg,
                          rules: [
                    (val) =>
                      !_unref(isEmpty)(val) ||
                      (_unref(isNumeric)(val)
                        ? (Number(val) > 0 && Number(val) < 100000000) ||
                          _ctx.$t('validation.betweenMoney', { param1: '1', param2: '99,999,999' })
                        : _unref(isMoneyType)(val) ||
                          _ctx.$t('validation.betweenMoney', { param1: '1', param2: '99,999,999' })),
                  ],
                          "lazy-rules": "",
                          onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "rules"]))
                      : _createCommentVNode("", true),
                    _cache[7] || (_cache[7] = _createElementVNode("label", null, "円以上", -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("label", { style: {"padding-left":"10px","padding-right":"10px"} }, "～", -1))
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_q_input, {
                      modelValue: data.upper_price_limit,
                      "onUpdate:modelValue": ($event: any) => ((data.upper_price_limit) = $event),
                      outlined: "",
                      clearable: "",
                      dense: "",
                      style: {"width":"200px"},
                      maxlength: "10",
                      "input-class": "text-right",
                      class: "input-area exception-right",
                      error: data.upErrFlg,
                      rules: [
                    (val) =>
                      !_unref(isEmpty)(val) ||
                      (_unref(isNumeric)(val)
                        ? (Number(val) > 0 && Number(val) < 100000000) ||
                          _ctx.$t('validation.betweenMoney', { param1: '1', param2: '99,999,999' })
                        : _unref(isMoneyType)(val) ||
                          _ctx.$t('validation.betweenMoney', { param1: '1', param2: '99,999,999' })),
                    (val) =>
                      Number(index) === 0 ? _unref(isEmpty)(val) || _ctx.$t('validation.required') : true,
                  ],
                      "lazy-rules": "",
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "rules"]),
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, "円未満", -1))
                  ])
                ]),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_q_input, {
                      modelValue: data.coefficient,
                      "onUpdate:modelValue": ($event: any) => ((data.coefficient) = $event),
                      outlined: "",
                      clearable: "",
                      dense: "",
                      style: {"width":"200px"},
                      maxlength: "6",
                      "input-class": "text-right",
                      class: "input-area exception-right",
                      error: data.coefErrFlg,
                      rules: [
                    (val) => (Number(index) ? _unref(isEmpty)(val) || _ctx.$t('validation.required') : true),
                    (val) => Number(val) >= 0.01 || '0.01以上で入力してください',
                    (val) =>
                      !_unref(isEmpty)(val) ||
                      _unref(isTwoDecimalPlaces)(val) ||
                      _ctx.$t('validation.two_decimal_places'),
                    (val) =>
                      !_unref(isEmpty)(val) ||
                      Number(val) < 1000 ||
                      _ctx.$t('validation.max_integer', { param1: '3' }),
                  ],
                      "lazy-rules": "",
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "error", "rules"])
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
            "button-area": _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_q_btn, {
                  type: "submit",
                  color: "primary",
                  style: {"width":"150px"},
                  label: '変更'
                }),
                _createVNode(_component_q_btn, {
                  type: "reset",
                  outline: "",
                  style: {"width":"150px","background":"var(--q-white) !important","color":"var(--q-delete)"},
                  icon: 'cached',
                  label: 'リセット'
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(AlertDialog, {
            display: dialogDisplayFlg.value,
            level: DIALOG_LEVEL,
            confirmation: dialogConfFlg.value,
            title: dialogTitle.value,
            text: dialogText.value,
            onComplete: _cache[3] || (_cache[3] = ($event: any) => (getCoefficients())),
            onConfirm: _cache[4] || (_cache[4] = ($event: any) => (editCoefficients())),
            onClose: _cache[5] || (_cache[5] = ($event: any) => (closeDialog()))
          }, null, 8, ["display", "confirmation", "title", "text"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})